import { useAtomValue } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useSurveyQueryFlattenCustomerAttributes } from '~/hooks/useSurveyQuery'
import { ensureExists } from '~/utils'

import { tabulatedColumnCustomerAttributeIdsAtom } from '../atoms'

export const useTabulatedColumnCustomerAttributes = () => {
  const { t } = useTranslation()
  const customerAttributes = useSurveyQueryFlattenCustomerAttributes()
  const tabulatedColumnCustomerAttributeIds = useAtomValue(
    tabulatedColumnCustomerAttributeIdsAtom,
  )

  return React.useMemo(
    () =>
      tabulatedColumnCustomerAttributeIds.map((customerAttributeId) => {
        const columnCustomerAttribute = customerAttributes.find(
          ({ id }) => id === customerAttributeId,
        )

        return ensureExists(columnCustomerAttribute, t('assertion_failed'))
      }),
    [customerAttributes, tabulatedColumnCustomerAttributeIds, t],
  )
}
